/* eslint-disable fp/no-delete */
import type { Node } from 'ricos-schema';

import { RICOS_NODE_TYPE_TO_DATA_FIELD } from '../../../consts';
import type { RicosEntityMap } from '../../../types';
import { ENTITY_DECORATION_TO_MUTABILITY, TO_RICOS_DECORATION_TYPE } from '../consts';
import { convertDecorationToDraftData } from './convertDraftPluginData';
import { createEntity } from './create-entity';
import type { DraftTypedDecoration } from './decorationParsers';

export const createDecorationEntityData = (
  decoration: DraftTypedDecoration,
  entityKey: number
): RicosEntityMap => {
  const { type, emojiData } = decoration;

  const data =
    emojiData ||
    convertDecorationToDraftData({
      ...decoration,
      type: TO_RICOS_DECORATION_TYPE[type],
    });
  if (data === undefined) {
    // eslint-disable-next-line no-console
    throw Error(`ERROR! Unknown entity type "${type}"!`);
  }

  const mutability = ENTITY_DECORATION_TO_MUTABILITY[type];
  return createEntity(entityKey, { type, mutability, data });
};

const getDynamicStyles = (node: Node) => {
  const { textStyle } = node[RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]] || {};
  const { textAlignment, lineHeight } = textStyle || {};
  const { paddingTop, paddingBottom } = node.style || {};
  return {
    textAlignment,
    lineHeight,
    paddingTop,
    paddingBottom,
  };
};

export const createTextBlockData = (node: Node) => {
  const { indentation = 0 } = node[RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]] || {};
  const { textAlignment, lineHeight, paddingTop, paddingBottom } = getDynamicStyles(node);
  return JSON.parse(
    JSON.stringify({
      textAlignment: textAlignment !== 'AUTO' ? textAlignment?.toLowerCase() : undefined,
      dynamicStyles: (paddingTop || paddingBottom || lineHeight) && {
        'padding-top': paddingTop,
        'padding-bottom': paddingBottom,
        'line-height': lineHeight,
      },
      depth: indentation,
    })
  );
};
